<div [style.width.px]="Width" [style.height.px]="Width">
    <canvas baseChart 
        [data]="ChartData"
        [type]="ChartType"
        [options]="ChartOptions">
    </canvas>
</div>
